export default __webpack_public_path__ + "static/media/raceBg.c96f9070.png";